// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"61c7162f","465":"5d99b8ad"}[chunkId] + ".chunk.js";
};